<template>
  <div class="infinite-multi-band-container" v-if="!loading">
    <div v-for="(sectionInfo, index) in multiSectionList" :key="sectionInfo.title + index" class="multi-section-container">
      <CommonBand :section-info="sectionInfo"></CommonBand>
    </div>
  </div>
</template>

<script>
import CommonBand from '@/components/section/template/CommonBand'
export default {
  name: 'InfiniteScrollMultiBand',
  components: {
    CommonBand
  },
  props: {
    multiSectionList: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
  .infinite-multi-band-container {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
</style>
